import { echartVerStackedBar } from '../common';
import { filterData } from './common';

export function echartUsuarisPerTitolBarYear(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT1Param');
  const datosFiltrados = filterData(datos.resultset, filterTipos);
  echartVerStackedBar(
    'chartUsuarisTitolBar',
    'no_dataUsuarisTitolBar',
    datosFiltrados,
    'Viatges',
    "ÚS D'EMT. USUARIS PER TÍTOL: HISTÒRIC ANUAL",
    '',
  );
}

export function echartUsuarisPerLiniaBarYear(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT2Param');
  const datosFiltrados = filterData(datos.resultset, filterTipos);
  echartVerStackedBar(
    'chartUsuarisLiniaBar',
    'no_dataUsuarisLiniaBar',
    datosFiltrados,
    'Viatges',
    "ÚS D'EMT. USUARIS PER LÍNIA: HISTÒRIC ANUAL",
    '',
  );
}
